import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Rampa, Sorter } from 'src/app/@shared/models/gaiolas.model';
import { GaiolaService } from 'src/app/services/gaiola/gaiola.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';
import { StatusParaSfxService } from 'src/app/services/status-sfx/status-para-sfx.service';
import { ClienteComboOutput } from 'src/app/@shared/models/consulta-detalhe';

@Component({
  selector: 'app-status-para-sfx',
  templateUrl: 'status-para-sfx.component.html',
  styleUrls: ['status-para-sfx.component.scss']
})
export class StatusParaSfxComponent implements OnInit {
  public listagemCLientes: ClienteComboOutput[]
  isloading: boolean = false;

  form = new FormGroup({
    clienteId: new FormControl('', Validators.required),
    nrts: new FormControl('', Validators.required)
  });

  constructor(
    private gaiolaService: GaiolaService,
    private service: StatusParaSfxService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {

    this.getClientes();

  }


  getClientes() {
    this.service.getClientesAtivos().subscribe(response => {
      console.log(response);
      this.listagemCLientes = response;
    }, error => {

    })
  }
  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  submit() {
    const linhas = this.form.value.nrts.split('\n');
    if (linhas.length > 500) {
      this.openSnackBar('Limit de 500 NRTS!', 'OK', 5000, 'danger-snackbar');
    } else {
      this.isloading = true;
      const data = {
        clienteId: this.form.value.clienteId,
        nrts: linhas
      }
      this.service.cadastrarStatusSFX(data).subscribe(response => {
        this.openSnackBar('Reenviado com sucesso!', 'OK', 5000, 'success-snackbar');
        this.isloading = false;
      }, error => {
        this.openSnackBar('Error ao cadastrar', 'OK', 5000, 'danger-snackbar');
        this.isloading = false;
      })
    }

  }

}
